module.exports = new __parcel__URL__("Receptie.1727b029.webp").toString();